<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="container">
    <div class="row">

      <!--<div class="col-lg-6 mobile-view pop-left">

        <div class="logo-wraper">
          <img src="../assets/Images/logo.png"/>
        </div>
        <h3>Iripash Learning Management</h3>


      </div>-->
      <div class="col-lg-12 set-mobile">
        <button mat-button class="close-button" [mat-dialog-close]="true">
          <mat-icon>close</mat-icon>
        </button>

        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">Sign Up Zenithguard Learning Management</h4>
        </div>
        <div class="modal-body">

          <form (ngSubmit)="signup(signupForm.value)" [formGroup]="signupForm" style="display:grid;">
            <div class="col-lg-12 row">
              <!--<div class="col-lg-4">
    <mat-form-field class="example-full-width input-tel">
      <input matInput placeholder="First Name" formControlName="firstName" maxlength="50" required />
      <mat-error *ngIf="submitted && f.firstName?.errors?.required">
        Enter First Name
      </mat-error>

    </mat-form-field>
  </div>-->
              <!--<div class="col-lg-4">
    <mat-form-field>
      <input matInput placeholder="Last Name" formControlName="lastName" maxlength="50" required />

      <mat-error *ngIf="submitted && f.lastName?.errors?.required">
        Enter Last Name
      </mat-error>


    </mat-form-field>
  </div>-->

              <div class="col-lg-6">
                <mat-form-field>
                  <input matInput type="email" placeholder="Email Id" formControlName="emailId" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.emailId.errors">
                    Enter Valid Email Id
                  </mat-error>
                </mat-form-field>
              </div>


              <!--<div class="col-lg-4">
                <mat-form-field>
                  <mat-label>Select Country </mat-label>
                  <mat-select formControlName="countryId" required matTooltip="Select Country" autocomplete="off">
                    <mat-form-field>
                      <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                    </mat-form-field>

                    <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.Id" (click)="SetCountryCode(d?.IsdCode)">
                      <img matSuffix [src]="d?.Url" style="height: 20px;width: 20px;" />
                      {{d?.Name}}({{d?.IsdCode}})
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.countryId.errors">
                    Select Country Code
                  </mat-error>
                </mat-form-field>



              </div>-->

              <div class="col-lg-6">

                <mat-form-field class="example-full-width otp">
                  <!--<span matPrefix>{{SignUpcountryIsdcode}} &nbsp;</span>-->
                  <span matPrefix>+91-&nbsp;</span>
                  <input matInput type="tel" placeholder="Mobile Number" formControlName="mobileNo" minlength="5" maxlength="13" required />

                  <mat-error *ngIf="submitted && f.mobileNo?.errors?.required">
                    Enter Mobile Number
                  </mat-error>
                  <mat-error *ngIf="f.mobileNo?.errors?.minlength">
                    Minimum Length 5
                  </mat-error>

                  <mat-error *ngIf="f.mobileNo?.errors?.maxlength">
                    Maximum Length 13
                  </mat-error>
                  <mat-error *ngIf="f.mobileNo?.errors?.pattern">
                    Invalid  Mobile Number
                  </mat-error>
                </mat-form-field>

              </div>
            </div>

            <div class="col-lg-12 row">
              <div class="col-lg-6">
                <mat-form-field>
                  <input matInput type="password" placeholder="Password" formControlName="password" maxlength="20" minlength="8" required>
                  <mat-error *ngIf="submitted && f.password.errors?.required">
                    Enter Password
                  </mat-error>
                  <mat-error *ngIf="f.password.hasError('pattern')">
                    Password must contain a minimum of 8 characters.
                  </mat-error>
                  <!-- <div *ngIf="f.Password.hasError('pattern')">Password must have atleast  8 characters, 1 number and 1 uppercase character</div>                           -->
                </mat-form-field>


              </div>

              <div class="col-lg-6">
                <mat-form-field>
                  <input matInput maxlength="20" minlength="8" placeholder="Confirm Password"
                         [type]="hide2 ? 'password' : 'text'" formControlName="confirmPassword"
                         required>
                  <!--<mat-icon class="eye-icon" matSuffix (click)="hide2 = !hide2">
          {{hide2 ? 'visibility_off' : 'visibility'}}
        </mat-icon>-->

                  <mat-error *ngIf="submitted && f.confirmPassword.errors?.required">
                    Enter Confirm Password
                  </mat-error>
                  <mat-error *ngIf="f.confirmPassword.hasError('pattern')">
                    Confirm Password must contain a minimum of 8 characters.
                  </mat-error>
                  <mat-error *ngIf="f.confirmPassword.hasError('confirmPasswordValidator')">Password and Confirm Password must be match</mat-error>
                  <!--<mat-error *ngIf="f.ConfirmPassword.hasError('pattern')">
            Password must contain a minimum of 7 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
        </mat-error>-->
                </mat-form-field>
              </div>

              

            </div>



          
            <button type="submit" mat-raised-button color="primary" class="login-btn" style="margin-top: 20px;background-color:#f44a4a;color:white !important;">Sign Up</button>

          </form>
        </div>
      </div>
    </div>
  </div>
</fieldset>
